var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tamara-login-form-footer-term-and-condition"},[_vm._v(" "+_vm._s(_vm.$t('i_accept'))+" "),_c('el-link',{staticClass:"tamara-login-form-footer-term-and-condition__link",attrs:{"target":"_blank","href":_vm.$t('terms_and_conditions_url')}},[_vm._v(" "+_vm._s(_vm.$t('terms_and_conditions'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }